import { AxiosResponse } from 'axios';
import { formatDate } from 'src/utils/helpers';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';
import {
    IServiceLoanerSummaryObject,
    ServiceLoanerTableData,
} from './models/service-loaner.service';

/**
 * Class responsible for manage the API calls and data request of the App
 */
export class ServiceLoanerService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };
    /**
     * Instantiates a new ClientService
     */
    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    /**
     * Retrieves the service loaner summary data
     * @param dealerId DealerId for service loaner detail
     */
    public async getSummary(dealerId: string): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/dslSummary`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: { dealerId, jwtToken: permissionsToken },
        };
        return this.client.sendRequest(request);
    }
    public mapResponse(
        data: IServiceLoanerSummaryObject[],
    ): ServiceLoanerTableData[] {
        return data.map((item) => {
            return {
                vin: item.Vin,
                model: item.ModelDescription,
                status: item.LeaseStatus,
                maturityDate: formatDate(item.MaturityDate),
                price: item.CurrentPurchasePrice,
                accountNumber: item.AccountNumber,
            };
        });
    }

    public async getDetails(
        dealerId: string,
        vin: string,
        country: string,
        accountNumber: number,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/dslDetail`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                vin,
                country,
                accountNumber,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }

    public async editDetails(
        dealerId: string,
        vin: string,
        accountNumber: number,
        StockNumber: string,
        Mileage: number,
        MileageDate: string,
        Notes: string,
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/mileage`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.put,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                vin,
                accountNumber,
                stockNumber: StockNumber,
                mileage: Mileage,
                mileageDate: MileageDate,
                notes: Notes,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }
}
